import { Observable } from "rxjs";
import { OrderBoxGroup } from "../model/order-box-group";

export abstract class BoxModelService {
    public abstract getBoxModel(): Observable<OrderBoxGroup | null>
}
